import { render, staticRenderFns } from "./203.vue?vue&type=template&id=55a2ffb3&scoped=true&"
var script = {}
import style0 from "./203.vue?vue&type=style&index=0&id=55a2ffb3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a2ffb3",
  null
  
)

export default component.exports